import { BrandType } from 'src/constants/Brands';
import { Subvertical, Vertical } from '../constants/Verticals';

export enum PageType {
    PERFORMANCE_PAGE = 'Performance page',
    CATEGORY_PAGE = 'Category page',
    PREQUIZ = 'Pre-quiz',
    QUIZ = 'Quiz',
    USER_PORTAL = 'User Portal',
    INBOX_ACTIVE = 'Inbox_Active',
    INBOX_CLOSED = 'Inbox_Closed',
    CHAT = 'Chat',
    LOGIN = 'Login',
    CREATE_ACCOUNT = 'Create Account',
    VERIFY_EMAIL = 'Verify Email',
    VERIFY_PHONE = 'Verify Phone',
    QUIZ_GATE = 'Quiz Gate',
    TREATMENT_ONBOARDING = 'Treatment Onboarding',
    TREATMENT_ONBOARDING__OVERVIEW = 'Treatment Onboarding - Overview',
    TREATMENT_ONBOARDING__STEP = 'Treatment Onboarding - Step',
    TREATMENT_ONBOARDING__ARTICLES = 'Treatment Onboarding - Articles',
    RESET_PASSWORD = 'Reset Password',
    RESET_PASSWORD_SUCCESS = 'Reset Password Success',
}

export enum DestinationCategory {
    QUIZ = 'Quiz',
    INBOX = 'Inbox',
    PRACTITIONER_CHAT = 'Practitioner Chat',
}

export enum ButtonAction {
    DIRECT = 'Direct',
    SUBMIT = 'Submit',
}

export type EventProps = {
    brand?: BrandType;
    button_action?: ButtonAction;
    vertical?: Vertical;
    subvertical?: Subvertical;
    quiz_name?: string;
    label?: string; // buttons / cards labels - CTAs
    question_name?: string;
    url?: string;
    quiz_type?: string;
    quiz_token?: string;
    version?: string;
    location?: string; // where it is located within a page
    destination_url?: string;
    destination_vertical?: Vertical;
    destination_category?: DestinationCategory;
    destination_brand?: BrandType;
    page_type?: PageType;
    medication?: string;
    referrer?: string;
    search?: string;
    experimentId?: string;
    variationId?: string;
    user_created_method?: string;
    user_created_source?: string;
    path?: string;
    title?: string;
    message_type?: string;
    chat_type?: string;
    gate_source?: string;
    gate_type?: string;
};
